export default "__VITE_ASSET__CzUiEVdz__"